import React, { useState } from 'react';
import { AutoComplete } from 'rsuite';

import { useDebouncedCallback } from 'use-debounce/lib';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import api from '~/services/api';

function FiltroTreinamentos({ onItemAdicionado }) {
  const [treinamentos, setTreinamentos] = useState([]);

  const buscarProfissoes = useDebouncedCallback(async (texto) => {
    if (texto) {
      try {
        const resposta = await api.get('treinamento', {
          params: {
            nome: texto,
          },
        });
        setTreinamentos(resposta.data);
      } catch (error) {
        toast.error(error.message);
      }
    }
  }, 500).callback;

  return (
    <AutoComplete
      data={treinamentos
        .map((b) => ({
          label: b.treinamento,
          value: b.treinamento,
          id: b.id,
        }))
        .slice(0, 10)}
      onSelect={onItemAdicionado}
      onChange={buscarProfissoes}
      placeholder="Treinamento"
    />
  );
}

FiltroTreinamentos.propTypes = {
  onItemAdicionado: PropTypes.func.isRequired,
};

export default FiltroTreinamentos;
